import { Skeleton, Typography, TypographyProps } from "@mui/material";

interface Props {
  loading?: boolean;
}
const GKTypography = ({
  children,
  loading,
  ...rest
}: TypographyProps & Props) => {
  return loading ? (
    <Skeleton width={"100%"} />
  ) : (
    <Typography {...rest}>{children}</Typography>
  );
};

export default GKTypography;
